import styled from 'styled-components'

const Ul = styled.ul`  
  margin-bottom: 2em;
  padding-left: 1rem;
  list-style: none;
`

export default Ul
